import { BetaTesterWarningIcon } from '@local/assets/icons'

import { useProfileMy } from '@web/hooks/useProfileMy'
import nClicks from '@web/libs/nlog/click/codes'
import { Header } from '@web/ui/components/Header/Simple'

import styles from '../index.module.scss'

const OthersHideReviewContent = () => {
  const { showProfileMy, handleClickBackButton, handleClickProfileMyButton, profileImageUrl, borderImageUrl } =
    useProfileMy()

  return (
    <div className="place_simple_wrapper_new">
      <Header
        showMy={showProfileMy}
        clickCode={{ back: nClicks.reviewEnd.BACK, my: nClicks.reviewEnd.PLACEMY }}
        onPrevClick={handleClickBackButton}
        onClickProfileMy={handleClickProfileMyButton}
        profileImageUrl={profileImageUrl}
        borderImageUrl={borderImageUrl}
      />
      <div className={styles.review_area}>
        <div className={styles.closed_review_area}>
          <BetaTesterWarningIcon className={styles.icon} aria-hidden="true" />
          <div className={styles.tit_area}>
            미노출 처리되어 확인할 수 없는
            <br />
            리뷰입니다.
          </div>
        </div>
      </div>
    </div>
  )
}

export default OthersHideReviewContent
